import { Link } from 'react-router-dom';
import { ArrowRight, Database, Globe, LayoutDashboard, Smartphone } from 'lucide-react';

const services = [
  {
    icon: Globe,
    title: 'Company & Product Websites',
    description:
      'Distinctive, responsive websites crafted to reflect your brand — not pulled from a template catalogue.',
  },
  {
    icon: LayoutDashboard,
    title: 'Admin Portals & Dashboards',
    description:
      'Purpose-built internal tools for inventory, surveys, reporting, and the workflows your team relies on.',
  },
  {
    icon: Database,
    title: 'API & Backend Systems',
    description:
      'Thoughtfully designed APIs, databases, and integrations — the quiet foundation behind great products.',
  },
  {
    icon: Smartphone,
    title: 'Ongoing Partnership',
    description:
      'Hosting, updates, refinements, and support — we stay with you after launch, not disappear.',
  },
];

export default function Services() {
  return (
    <div className="page-shell">
      <div className="max-w-3xl">
        <h1 className="section-heading">Our Services</h1>
        <p className="section-subheading">
          Boutique software services — carefully scoped, personally delivered, from first idea to
          long-term care.
        </p>
      </div>

      <div className="mt-10 grid gap-5 sm:mt-12 sm:grid-cols-2 sm:gap-6">
        {services.map((service) => (
          <div
            key={service.title}
            className="rounded-2xl border border-slate-200 p-6 transition hover:border-brand-200 hover:shadow-md sm:p-8"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
              <service.icon className="h-6 w-6" />
            </div>
            <h2 className="mt-5 text-xl font-bold text-brand-900 sm:text-2xl">{service.title}</h2>
            <p className="mt-3 text-base font-semibold text-slate-600 sm:text-lg">{service.description}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-2xl border border-brand-100 bg-brand-50 px-5 py-8 sm:mt-16 sm:px-8 sm:py-10 lg:px-12">
        <h2 className="text-2xl font-extrabold text-brand-900 sm:text-3xl">Wondering if we&apos;re the right fit?</h2>
        <p className="mt-3 max-w-2xl text-base font-semibold text-slate-600 sm:text-lg">
          Every project starts with a conversation. Share what you&apos;re building and we&apos;ll
          have an honest discussion about how we can help — no pressure, no obligation.
        </p>
        <Link to="/contact" className="btn-primary mt-6 inline-flex sm:w-auto">
          Talk to us
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
